import { JobTitle } from '@pflegia/data-access';
import { FunnelQuestion, FunnelQuestionCategory } from '@pflegia/types/api/funnel/questions';
import { LocalFunnelStep } from '@pflegia/ui/funnel/types';
import { FunnelAnswers } from '@pflegia/ui/pflegia/funnel/types/funnel-answers';

export const personalDataStep: LocalFunnelStep<JobTitle, FunnelAnswers, FunnelQuestion.PersonalData> = {
  category: FunnelQuestionCategory.Register,
  key: FunnelQuestion.PersonalData,
};
